export const fetchKnowiWidgets = () => {
  return {
    type: "FETCH_KNOWI_WIDGETS",
  };
};

export const fetchKnowihash = (contentFilter) => {
  return {
    type: "FETCH_KNOWI_HASH",
    contentFilter,
  };
};

export const storeWidgetList = (contentFilter) => {
  return {
    type: "STORE_WIDGETS",
    contentFilter
  }
}
